var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('Header'),_c('SpacerBar'),_c('v-main',[_c('AutoBay'),_c('SelfServe'),_c('Amenities'),_c('Platinum'),_c('Hours'),_c('Contact')],1),_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }